import { find } from 'lodash'

export default {
  /**
   * Check if a settings has deletion pending
   */
  isSettingsDeletionPending: state => settingsId =>
    state.settingsDeletionPending.includes(settingsId),

  /**
   * Get settings by id
   */
  getSettingsById: state => settingsId =>
    find(state.settings, settings => settings.id === settingsId)
}
